import * as React from "react";
import ReactGA from "react-ga";
import {connect} from "react-redux";
import Error from "src/components/Error";
import ScrollyContainer from "src/containers/ScrollyContainer";
import * as actions from "src/store/actions/index";
import "./App.scss";
import {GA} from "./constants";
import {IData} from "./ScrollyInterface";
import {IStateApp} from "./store/StoreInterface";

class App extends React.Component<{
		data: IData;
		error: boolean;
		onInitData: () => void;
	},
	{}> {
	constructor(props: { data: IData; error: boolean; onInitData: () => void }) {
		super(props);
		this.props.onInitData();
		const page = window.location.pathname;
		ReactGA.initialize(GA.ID);
		ReactGA.set({page});
		ReactGA.pageview(page);
	}

	public render() {
		const scrollyContainer = this.props.data ? (
			<ScrollyContainer data={this.props.data}/>
		) : (
			<Error error={this.props.error}/>
		);
		return <div className="App">{scrollyContainer}</div>;
	}
}

const mapStateToProps = (state: IStateApp) => {
	return {
		data: state.data.data,
		error: state.data.error
	};
};

const mapDispatchToProps = (dispatch: any) => {
	return {
		onInitData: () => dispatch(actions.initData())
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.tsx